export default "__VITE_ASSET__c19fbccd__"